var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.classes,style:(_vm.style),attrs:{"data-components":"CheckedSvg","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 10"}},[_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 5.192l1.4-1.346L5 7.308 12.6 0 14 1.346 5 10"}}),_c('path',{attrs:{"fill":"none","d":"M-5-7h24v24H-5z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }